import { ROUTE_ACTION_PLAN } from '@/constants/routes';
import { Box, Link, Text } from '@cmpsr/components';
import { Link as RouterLink } from 'react-router-dom';

export default function EmptyState() {
  return (
    <Box
      textAlign="left"
      px="5"
      py="8"
      pt={{ base: '12', lg: '8' }}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
    >
      <Text variant="text-header-XL" mb="spacer-2">
        You finished all your tests!
      </Text>
      <Text variant="text-body-regular">Check out your Action Plan to see how you can continue reducing your risk</Text>
      <Link as={RouterLink} to={ROUTE_ACTION_PLAN} variant="primary" size="m" mt="8">
        Action Plan
      </Link>
    </Box>
  );
}
